import {Type} from "../helper";
import {t} from "@lingui/macro";

export function getServerUrl(transactionType) {
    switch (transactionType) {
        case Type.sale_quote:
            return '/sales/quotes';
        case Type.sale_order:
            return '/sales/orders';
        case Type.sale_delivery_order:
            return '/sales/delivery_orders';
        case Type.sale_invoice:
        case Type.sale_invoice_cash:
            return '/sales/invoices';
        case Type.opening_invoice:
            return '/sales/opening_invoices';
        case Type.sale_credit_note:
            return '/sales/credit_notes';
        case Type.opening_sale_credit_note:
            return '/sales/opening_credit_notes';
        case Type.sale_payment:
            return '/sales/payments';
        case Type.sale_refund:
            return '/sales/refunds';
        case Type.purchase_order:
            return '/purchases/orders';
        case Type.purchase_goods_received_note:
            return '/purchases/goods_received_notes';
        case Type.purchase_bill:
        case Type.purchase_bill_cash:
        case Type.purchase_bill_claim:
            return '/purchases/bills';
        case Type.opening_bill:
            return '/purchases/opening_bills';
        case Type.purchase_credit_note:
            return '/purchases/credit_notes';
        case Type.opening_purchase_credit_note:
            return '/purchases/opening_credit_notes';
        case Type.purchase_payment:
            return '/purchases/payments';
        case Type.purchase_refund:
            return '/purchases/refunds';
        case Type.bank_income:
            return '/banking/incomes';
        case Type.bank_expense:
            return '/banking/expenses';
        case Type.bank_transfer:
            return '/banking/transfers';
        case Type.journal_entry:
            return '/journal_entries';
        case Type.contra:
            return '/accounting/contras';
        case Type.tax_deemed_payment:
            return '/taxes/deemed_payments';
        case Type.stock_adjustment:
            return '/stock/adjustments';
        case Type.opening_stock_adjustment:
            return '/stock/opening_stock_adjustments';
        case Type.stock_transfer:
            return '/stock/transfers';
        case Type.stock_value:
            return '/stock/values';
        case Type.sales:
            return '/sales';
        case Type.purchases:
            return '/purchases';
        case Type.banking:
            return '/banking';
        case Type.report_sst_recovered_payments:
            return '/sales/invoices';

        default:
            throw new Error(t`No URL found for the transaction type: ${transactionType}`);
    }
}
